import { useState } from 'react';
import styled from 'styled-components';
import Logo from '../StoraEnsoComponents/Logo';
import Notification from '../StoraEnsoComponents/Notification';
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { Navigate } from 'react-router-dom';
import { loginRequest } from '../../config/authConfig';
import { HOME } from "../../Routes";
import PageWrapper from '../Layout/pageWrapper';
import { Container } from '../Container';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 1rem 0;
  height: 100vh;
`;

const Title = styled.h1`
  margin: 1rem 0;
`;

const Link = styled.span`
  color: ${({theme}) => theme.colors.link};
  cursor: pointer;

  &:hover {
    color: ${({theme}) => theme.colors.link_hover};
  }
`;

const ErrorWrapper = styled.div`
  margin-bottom: 1rem;
`;

function LoginPage () {
  const [error, setError] = useState(null);
  const isAuthenticated = useIsAuthenticated();
  const { inProgress, instance } = useMsal();

  const handleLogin = () => {
    instance.loginRedirect(loginRequest).catch(e => {
      setError(e);
      console.error('Login ERROR: ', e);
    });
  }

  if(inProgress !== InteractionStatus.None) {
    return null;
  }

  if(isAuthenticated) {
    return <Navigate to={HOME} replace={true} />
  }

  return (
    <PageWrapper>
      <Container>
        <Content>
          <Logo />
          <Title className="se-header-title-heading">Drones</Title>

          {
            error && (
              <ErrorWrapper>
                <Notification kind="negative" onClose={() => setError(null)}>
                  An error has occurred!
                </Notification>
              </ErrorWrapper>
            )
          }

          <p>You are not logged in, please <Link id="Sign_in" onClick={handleLogin}>sign-in</Link> to use the application.</p>
        </Content>
      </Container>
    </PageWrapper>
  );
}

export default LoginPage;